<template>
    <div class="flat-mail-input-flats-crm" id="flat-mail-input-flats-crm">
        <form class="form-in" v-if="formVisible" @submit="sendFlatMail">
            <div class="form-group">
                <input type="email" name="email" class="form-control"  autocomplete="off" placeholder="E-mail" v-model="email" v-validate="{rules: { required: true, regex: regexRules.email }}">
            </div>
            <div class="btn-send">
                <button class="btn-submit btn-success" type="button" @click="sendFlatMail" :disabled="errors.any()">
                    <svgIcon name="mail-send" class="icon-plane"/>
                </button>
            </div>
        </form>
        <div class="successMessage" v-else>
            <h3>отправлено</h3>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'formMail',
        props: ['options'],
        data () {
            return {
                formVisible: true,
                email: '',
                regexRules: {
                    email: /[a-zA-Z0-9_\.\+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-\.]+/
                }
            }
        },
        components: {
            svgIcon,
        },
        computed: mapGetters({
        }),
        methods: {
            sendFlatMail(e) {
                e.preventDefault();
                var querystring = require('querystring');
                var urlForm = '/formFlatCrm.php';
                var data = {
                    'pdf': this.options[0].pdf,
                    'name': this.options[0].name,
                    'link': this.options[0].flat_link,
                    'path_logo': './static/' + this.options[0].project_name + '/images/logo.png',
                    'path_bazis': './static/' + this.options[0].project_name + '/images/bazis.png',
                    'path_index_pic': './static/' + this.options[0].project_name + '/images/index-pic.jpg',
                    'path_phone': './static/' + this.options[0].project_name + '/images/phone.png',
                    'path_html': './static/' + this.options[0].project_name + '/send_flat.html',
                    'subject': 'Ваша кваритра в ' + this.CapitalizeID(this.options[0].project_name),
                    'mail': this.email
                };
                // if (window.host == 'yassytower') {
                //     urlForm = '/formFlatLandYassy.php'
                //     var data = {
                //         'pdf': this.options[0].pdf,
                //         'name': this.options[0].name,
                //         'mail': this.email
                //     };
                // }
                this.$validator.validate().then(result => {
                    if(result) {
                        this.formVisible = false
                        // console.log(data);
                        axios.post(urlForm, querystring.stringify(data));
                        setTimeout(() => {
                            this.$store.commit('openFormMailFlatsCRM', false)
                            this.$store.commit('openFormMailFlatsCRM_mobileSet', false)
                        }, 1500);
                        
                       
                    } else {
                        console.log('Form Send mail with errors');
                    }
                });
            },
            CapitalizeID(s) {
                if (typeof s !== 'string') return ''
                return s.charAt(0).toUpperCase() + s.slice(1)
            },
        },
        mounted () {
        }
    }
</script>

<style lang="scss" scoped>
    @import '@/styles/components/forms/form-mail-flat-crm.scss';
    // @import '@/styles/components/forms/forms-respond/form-mail-respond.scss';
</style>